/* eslint-disable require-yield */
import { takeLatest, call, put } from "redux-saga/effects";
import { CANCEL } from "redux-saga";
import Request from "shared/Request";
import axios from "axios";

function* autoSave() {
  yield takeLatest("SAVE_PAGE", savePage);
}

function* savePage({ values, fn }) {
  console.log("Autosave: Saving Page");
  const cancelSource = axios.CancelToken.source();
  yield put({ type: "SAVE_PAGE_START" });
  try {
    const promise = () => {
      const request = Request.put(values.url, values.params, {
        cancelToken: cancelSource.token
      }).catch(error => {
        fn({ error });
      });
      request[CANCEL] = () => {
        cancelSource.cancel();
      };
      return request;
    };
    const resp = yield call(promise);
    fn(resp);
  } catch (error) {
    fn({ error });
  }
}

export default autoSave;
